import * as tslib_1 from "tslib";
import ReadOnlyRecipient from './ReadOnlyRecipient';
import { observer } from 'mobx-react';
import { RecipientType } from 'owa-recipient-common/lib/store/schema/RecipientType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import strings from 'owa-strings/owa-common-strings';
import * as React from 'react';
var styles = require('./ReadOnlyRecipientWell.scss');
var classNames = require('classnames');
var ReadOnlyRecipientWell = /** @class */ (function (_super) {
    tslib_1.__extends(ReadOnlyRecipientWell, _super);
    function ReadOnlyRecipientWell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReadOnlyRecipientWell.prototype.render = function () {
        var _this = this;
        var _a = this.props, recipients = _a.recipients, allowRenderEmptyWell = _a.allowRenderEmptyWell, wellLabelText = _a.wellLabelText, recipientType = _a.recipientType, className = _a.className, renderSelf = _a.renderSelf, disableHover = _a.disableHover, trailingComponent = _a.trailingComponent;
        if (recipients && (allowRenderEmptyWell || recipients.length > 0)) {
            wellLabelText = wellLabelText || this.getWellLabelTextForRecipientType(recipientType);
            var wellLabel = recipientType != RecipientType.None ? (React.createElement("label", { className: styles.label }, wellLabelText)) : null;
            return (React.createElement("div", { className: className },
                wellLabel,
                React.createElement("div", { className: styles.divFixer, ref: function (ref) { return (_this.recipientsParentRef = ref); } }, recipients.map(function (recipient, index) {
                    var isSelf = index == 0 &&
                        recipient.email.EmailAddress ==
                            getUserConfiguration().SessionSettings.UserEmailAddress &&
                        renderSelf;
                    // Using an index as part of the key is sub-optimal, but the recipient array
                    // can contain duplicate data that has no other means of differentiating.
                    return (React.createElement(ReadOnlyRecipient, { key: recipient.email.EmailAddress + "_" + index, viewState: recipient, name: recipient.email.Name, emailAddress: recipient.email.EmailAddress, renderSelf: isSelf, disableHoverAndKeyPress: disableHover, mailBoxType: recipient.email.MailboxType }));
                })),
                React.createElement("div", { className: classNames(styles.divFixer, styles.wellTrailingComponent) }, trailingComponent)));
        }
        else {
            return null;
        }
    };
    ReadOnlyRecipientWell.prototype.getWellLabelTextForRecipientType = function (recipientType) {
        switch (recipientType) {
            case RecipientType.To:
                return strings.toRecipientWellLabel;
            case RecipientType.Cc:
                return strings.ccRecipientWellLabel;
            default:
                return '';
        }
    };
    ReadOnlyRecipientWell = tslib_1.__decorate([
        observer
    ], ReadOnlyRecipientWell);
    return ReadOnlyRecipientWell;
}(React.Component));
export default ReadOnlyRecipientWell;
//# sourceMappingURL=ReadOnlyRecipientWell.js.map